import { render } from "./commonReportExplain.vue?vue&type=template&id=5daa6b05&scoped=true"
import script from "./commonReportExplain.vue?vue&type=script&lang=js"
export * from "./commonReportExplain.vue?vue&type=script&lang=js"

import "./commonReportExplain.vue?vue&type=style&index=0&id=5daa6b05&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daa6b05"]])

export default __exports__